<script lang="ts">
    import type {Department} from 'src/typings';
    import type {ViewableDepartmentsHierarchy} from 'src/features/departments/types';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {exists} from 'shared/utils/custom-utils';
    import {createEventDispatcher} from 'svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let department: ViewableDepartmentsHierarchy;
    export let homeDepartment: Department | null = null;

    const dispatch = createEventDispatcher<{'department-select': Department}>();
</script>

<div class="department-hierarchy">
    <button on:click={() => dispatch('department-select', department)}>
        {pipe(department, loc())}

        {#if department.id === homeDepartment?.id}
            <span class="home-department">
                <UIcon icon="map-marker-home"/>
            </span>
        {/if}
    </button>

    {#if exists(department.children) && department.children.length > 0}
        <div class="subdepartments">
            {#each department.children as subdepartment}
                <svelte:self department={subdepartment} {homeDepartment} on:department-select/>
            {/each}
        </div>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .department-hierarchy {
        display: flex;
        flex-direction: column;
        gap: @spacing-s;

        button {
            background: none;
            padding: @spacing-xs;
            margin: 0;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: @spacing-s;
            outline: none;
            color: var(--text-color);
            text-decoration: none;
            transition: color 0.2s ease-in-out;
            text-align: start;
            position: relative;

            &:before {
                content: '';
                position: absolute;
                left: -3px;
                right: -3px;
                top: 0;
                bottom: 0;
                border-radius: @border-radius-default;
                background-color: transparent;
                z-index: -1;
                transition: background-color 0.2s ease-in-out;
            }

            &:hover {
                color: var(--accent-blue);

                &:before {
                    background-color: @themed-body-bg-blue-highlighted;
                }
            }

            .home-department {
                color: @themed-text-muted;
            }
        }

        .subdepartments {
            display: flex;
            flex-direction: column;
            gap: @spacing-s;
            margin-left: @spacing-m;
            padding-left: @spacing-m;
            border-left: 1px solid var(--accent-blue);
        }
    }
</style>